const styles = (theme) => ({
  menu: {
    paddingTop: '15px',
    paddingBottom: '15px',
  },
  username: {
    cursor: 'pointer',
    marginLeft: '10px',

    '&:hover': {
      textDecoration: 'underline',
    },
  },
  boligmappaPlusSign: {
    position: 'absolute',
    top: '-7px',
    right: '-7px',
    width: '16px',
    height: '16px',
    background:
      'conic-gradient(from 181.1deg at 51.19% 50.39%, #FA9703 0deg, #ECD821 114.64deg, #F4B40F 182.51deg, #F7DF0A 278.31deg, #F89408 360deg)',
    borderRadius: '50%',

    '&:before,&:after': {
      content: '""',
      position: 'absolute',
      backgroundColor: '#000',
    },
    '&:before': {
      width: '10px',
      height: '2px',
      top: 'calc(50% - 1px)',
      left: '3px',
    },
    '&:after': {
      width: '2px',
      height: '10px',
      top: '3px',
      left: 'calc(50% - 1px)',
    },
  },
  listItemText: {
    width: '100%',
  },
  listItem: {
    padding: '10px',
    cursor: 'pointer',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      '&:hover': {
        background: 'rgba(0, 0, 0, 0.08)',
      },
    },
  },
  divider: {
    margin: '10px 0',
  },
});

export default styles;
